import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";

const COLORS = ["#3b82f6","#10b981","#f59e0b","#ef4444","#8b5cf6","#06b6d4"];

// ── normalize any id to string (same helper as parent) ──
const sid = (v) => String(v ?? "");

const mkInitials = (name = "") =>
  name.split(" ").filter(Boolean).map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "?";

const AssigneeBreakdown = ({ stories = [], users = [] }) => {

  const rows = useMemo(() => {
    const map = {};

    stories.forEach((st) => {
      const devSP  = Number(st.storyPoints)     || 0;  // Developer SP
      const testSP = Number(st.testStoryPoints) || 0;  // Tester SP
      const status = (st.status || "").toUpperCase();

      const assignees = st.storyUsers && st.storyUsers.length > 0
        ? st.storyUsers
        : null;

      if (!assignees) {
        // No assignees — bucket under Unassigned using devSP
        const uid = "__none__";
        if (!map[uid]) {
          map[uid] = { uid, name: "Unassigned", storyCount: 0, totalSP: 0, toDoSP: 0, inProgressSP: 0, completed: 0, toDo: 0, completedSP: 0 };
        }
        map[uid].storyCount += 1;
        map[uid].totalSP += devSP + testSP;
        if (status === "TODO" || status === "TO_DO")             { map[uid].toDoSP += devSP + testSP; map[uid].toDo += 1; }
if (status === "INPROGRESS" || status === "IN_PROGRESS" || status === "INTESTING")   map[uid].inProgressSP += devSP + testSP;
        if (status === "COMPLETED")                              { map[uid].completed++; map[uid].completedSP += devSP + testSP; }
      } else {
        assignees.forEach((su) => {
          const user = su.user || su;
          const uid  = sid(user.id ?? user._id ?? "__none__");
          const name = user.name
            || `${user.firstName || ""} ${user.lastName || ""}`.trim()
            || user.email
            || "Unassigned";

          // ── KEY FIX: DEVELOPER gets storyPoints, TESTER gets testStoryPoints ──
          const userRole = (su.userRole || "").toUpperCase();
          const isTester = userRole === "TESTER"
            || su.user?.isQaFlag === true
            || users.some((u) => String(u.id) === String(user.id ?? user._id) && u.isQaFlag === true);
          const userSP = isTester ? testSP : devSP;

          if (!map[uid]) {
            map[uid] = { uid, name, storyCount: 0, totalSP: 0, toDoSP: 0, inProgressSP: 0, completed: 0, toDo: 0, completedSP: 0 };
          }
          map[uid].storyCount += 1;
          map[uid].totalSP    += userSP;
          if (status === "TODO" || status === "TO_DO")             { map[uid].toDoSP += userSP; map[uid].toDo += 1; }
if (status === "INPROGRESS" || status === "IN_PROGRESS" || status === "INTESTING")   map[uid].inProgressSP += userSP;
          if (status === "COMPLETED")                              { map[uid].completed++; map[uid].completedSP += userSP; }
        });
      }
    });

    return Object.values(map)
      .map((e) => ({
        ...e,
        initials: mkInitials(e.name),
        // Progress = completedSP / totalSP
        pct: e.totalSP > 0 ? Math.round((e.completedSP / e.totalSP) * 100) : 0,
      }))
      .sort((a, b) => b.totalSP - a.totalSP);
  }, [stories, users]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const paginatedRows = rows.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div style={{
      background:"#fff", borderRadius:12, border:"1px solid #e5e7eb",
      boxShadow:"0 1px 4px rgba(0,0,0,.06)", overflow:"hidden"
    }}>
      {/* Header */}
      <div style={{ padding:"14px 18px 4px" }}>
        <div style={{ fontSize:13, fontWeight:700, color:"#111827" }}>Assignee Breakdown</div>
        <div style={{ fontSize:11, color:"#9ca3af", marginBottom:2 }}>
          Story points and progress per team member
        </div>
      </div>

      {/* Table */}
      <div style={{ overflowX:"auto" }}>
        <Table hover style={{ fontSize:12, marginBottom:0 }}>
          <thead>
            <tr style={{ background:"#f9fafb" }}>
              {[
                { label:"Assignee",      align:"left"  },
                { label:"Assigned (SP)", align:"right" },
{ label:"To Do",         align:"right" },
{ label:"In Progress (SP)", align:"right" },
                { label:"Completed (SP)", align:"right" },
                { label:"Progress",      align:"right" },
              ].map((h, i) => (
                <th key={h.label} style={{
                  padding: i === 0 ? "10px 18px" : "10px 14px",
                  fontWeight:600, fontSize:12, color:"#6b7280",
                  textAlign: h.align,
                  whiteSpace:"nowrap", borderBottom:"1px solid #e5e7eb"
                }}>
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign:"center", padding:28, color:"#9ca3af", fontSize:12 }}>
                  No assignee data available for this sprint.
                </td>
              </tr>
) : paginatedRows.map((row, i) => (
                <tr key={row.uid} style={{ borderBottom:"1px solid #f3f4f6" }}>

                {/* Assignee avatar + name */}
                <td style={{ padding:"10px 18px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <div style={{
                      width:30, height:30, borderRadius:"50%",
                      background: COLORS[i % COLORS.length],
                      color:"#fff", display:"flex", alignItems:"center",
                      justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0
                    }}>
                      {row.initials}
                    </div>
                    <div>
                      <span style={{ fontWeight:500, color:"#374151" }}>{row.name}</span>
                      <div style={{ fontSize:10, color:"#9ca3af" }}>
                        {row.storyCount} {row.storyCount === 1 ? "story" : "stories"}
                      </div>
                    </div>
                  </div>
                </td>

                {/* Assigned story points */}
                <td style={{ padding:"10px 14px", textAlign:"right", fontWeight:700, color:"#111827" }}>
                  {row.totalSP > 0 ? row.totalSP : <span style={{ color:"#9ca3af" }}>—</span>}
                </td>

                {/* To Do SP */}
<td style={{ padding:"10px 14px", textAlign:"right", color:"#6b7280" }}>
  {row.toDoSP > 0 ? row.toDoSP : 0}
</td>

                {/* In Progress SP */}
<td style={{ padding:"10px 14px", textAlign:"right", color:"#6b7280" }}>
  {row.inProgressSP > 0 ? row.inProgressSP : 0}
</td>

                {/* Completed SP */}
<td style={{ padding:"10px 14px", textAlign:"right", fontWeight:700, color:"#2563eb" }}>
  {row.completedSP > 0 ? row.completedSP : 0}
</td>

                {/* Progress bar + % */}
                <td style={{ padding:"10px 18px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, justifyContent:"flex-end" }}>
                    <div style={{
                      width:72, height:6, background:"#e5e7eb",
                      borderRadius:4, overflow:"hidden"
                    }}>
                      <div style={{
                        width:`${row.pct}%`, height:"100%", borderRadius:4,
                        background: row.pct >= 80 ? "#16a34a"
                                  : row.pct >= 50 ? "#2563eb"
                                  : "#f59e0b",
                        transition:"width .3s ease",
                      }} />
                    </div>
                    <span style={{ fontSize:11, color:"#6b7280", minWidth:30, textAlign:"right" }}>
                      {row.pct}%
                    </span>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Footer */}
      {rows.length > 0 && (
        <div style={{
          padding:"10px 18px", fontSize:11, color:"#9ca3af",
          borderTop:"1px solid #f3f4f6", display:"flex",
          justifyContent:"space-between", alignItems:"center", gap: 12
        }}>
          <span>
            Showing {Math.min((currentPage - 1) * itemsPerPage + 1, rows.length)}
            {"–"}
            {Math.min(currentPage * itemsPerPage, rows.length)} of {rows.length}{" "}
            {rows.length === 1 ? "member" : "members"}
          </span>

          {totalPages > 1 && (
            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  border:"1px solid #e5e7eb", background:"#fff", borderRadius:6,
                  padding:"3px 9px", fontSize:11, cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  color: currentPage === 1 ? "#d1d5db" : "#374151",
                }}
              >
                Prev
              </button>
              <span style={{ fontSize:11, color:"#6b7280" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                style={{
                  border:"1px solid #e5e7eb", background:"#fff", borderRadius:6,
                  padding:"3px 9px", fontSize:11, cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  color: currentPage === totalPages ? "#d1d5db" : "#374151",
                }}
              >
                Next
              </button>
            </div>
          )}

          <span>
            {stories.length} {stories.length === 1 ? "story" : "stories"} total
          </span>
        </div>
      )}
    </div>
  );
};

export default AssigneeBreakdown;